import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
export function ModifyProfile() {
  const enrolledCourses = [{
    name: 'Ethics & The Rules (with NAR Code of Ethics)',
    status: '(Course enrolled)',
    creditType: '3 hrs. Comm. Standards',
    created: '04/23/2012'
  }, {
    name: "Don't Lose Your License",
    status: '(Course enrolled)',
    creditType: '3 hrs. Comm. Standards',
    created: '04/11/2012'
  }, {
    name: 'The Owner Is In Default',
    status: '(Course enrolled)',
    creditType: '3 hrs. Legal Issues',
    created: '04/11/2012'
  }, {
    name: 'They Are A Protected Class',
    status: '(Course enrolled)',
    creditType: '3 hrs. Fair Housing',
    created: '04/11/2012'
  }, {
    name: 'A Letter From ADRE',
    status: '(Course enrolled)',
    creditType: '3 hrs. Comm. Standards',
    created: '04/11/2012'
  }, {
    name: 'Are They Represented?',
    status: '(Section in progress)',
    creditType: '3 hrs. Agency Law',
    created: '04/11/2012'
  }, {
    name: 'Follow All The Laws',
    status: '(Course enrolled)',
    creditType: '3 hrs. Legal Issues',
    created: '04/11/2012'
  }, {
    name: 'No Secrets',
    status: '(Course enrolled)',
    creditType: '3 hrs. Disclosure',
    created: '04/11/2012'
  }, {
    name: 'Common Contract Issues',
    status: '(Section in progress)',
    creditType: '3 hrs. Contract Law',
    created: '04/11/2012'
  }];
  return <div className="space-y-6" data-id="element-522">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-523">Edit User</h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-524">
        {/* Left Column: Profile Fields */}
        <Card data-id="element-525">
          <CardHeader data-id="element-526">
            <CardTitle data-id="element-527">Profile Information</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4" data-id="element-528">
            <Input label="Title" defaultValue="Mr" data-id="element-529" />
            <Input label="First Name" defaultValue="Admin" data-id="element-530" />
            <Input label="Last Name" defaultValue="Admin" data-id="element-531" />
            <Input label="Company" defaultValue="Desert Sage Seminars" data-id="element-532" />
            <Input label="Address 1" defaultValue="15560 N. Frank Lloyd W" data-id="element-533" />
            <Input label="Address 2" defaultValue="#B4-5185" data-id="element-534" />
            <Input label="City" defaultValue="Scottsdale" data-id="element-535" />
            <Select label="State/Province *" defaultValue="AZ" options={[{
            value: 'AZ',
            label: 'Arizona'
          }, {
            value: 'CA',
            label: 'California'
          }, {
            value: 'NV',
            label: 'Nevada'
          }]} data-id="element-536" />
            <Input label="Zip" defaultValue="85260" data-id="element-537" />
            <Input label="Phone" defaultValue="602-377-6207" data-id="element-538" />
            <Input label="Email" helperText="Leave blank to keep existing email (administration@desertsageseminars.com)" data-id="element-539" />
            <Input label="Fax" data-id="element-540" />
            <Input label="How Did You Hear About Us" data-id="element-541" />
            <Input label="Facebook" data-id="element-542" />
            <Input label="Username" helperText="Leave blank to keep existing username (admin)" data-id="element-543" />
            <Input type="password" label="Password" helperText="Leave blank to keep existing password" data-id="element-544" />

            <div className="py-2" data-id="element-545">
              <a href="#" className="text-blue-600 hover:underline text-sm" data-id="element-546">
                Click here to obtain your license expiration date from ADRE
              </a>
            </div>

            <Input label="Available Courses" defaultValue="0" data-id="element-547" />

            <div className="pt-4" data-id="element-548">
              <Button data-id="element-549">Update</Button>
            </div>
          </CardContent>
        </Card>

        {/* Right Column: Course Assignments */}
        <div className="space-y-6" data-id="element-550">
          <Card data-id="element-551">
            <CardContent className="space-y-4 pt-6" data-id="element-552">
              <Select label="Course" options={[{
              value: '1',
              label: 'NAR Code of Ethics (NO CE CREDIT)'
            }]} data-id="element-553" />
              <Select label="Statuses" defaultValue="enrolled" options={[{
              value: 'completed',
              label: 'Course Completed'
            }, {
              value: 'in_progress',
              label: 'Course in Progress'
            }, {
              value: 'emailed',
              label: 'Certificate Emailed'
            }, {
              value: 'enrolled',
              label: 'Course Enrolled'
            }, {
              value: 'section_progress',
              label: 'Section in Progress'
            }]} data-id="element-554" />
              <Button className="w-full gap-2" data-id="element-555">
                <Plus className="h-4 w-4" data-id="element-556" />
                Add
              </Button>
            </CardContent>
          </Card>

          <Card data-id="element-557">
            <CardHeader data-id="element-558">
              <CardTitle data-id="element-559">Enrolled Courses</CardTitle>
            </CardHeader>
            <div className="overflow-x-auto" data-id="element-560">
              <table className="w-full text-sm text-left" data-id="element-561">
                <thead className="bg-slate-800 text-white font-medium border-b border-slate-700" data-id="element-562">
                  <tr data-id="element-563">
                    <th className="px-4 py-3 border-r border-slate-700" data-id="element-564">
                      Course Name
                    </th>
                    <th className="px-4 py-3 border-r border-slate-700" data-id="element-565">
                      Credit Type
                    </th>
                    <th className="px-4 py-3 border-r border-slate-700" data-id="element-566">
                      Created
                    </th>
                    <th className="px-4 py-3" data-id="element-567">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200" data-id="element-568">
                  {enrolledCourses.map((course, index) => <tr key={index} className="hover:bg-slate-50" data-id="element-569">
                      <td className="px-4 py-3 border-r border-slate-200" data-id="element-570">
                        <div className="text-slate-900" data-id="element-571">{course.name}</div>
                        <div className="text-slate-500 text-xs mt-0.5" data-id="element-572">
                          {course.status}
                        </div>
                      </td>
                      <td className="px-4 py-3 border-r border-slate-200 text-slate-700" data-id="element-573">
                        {course.creditType}
                      </td>
                      <td className="px-4 py-3 border-r border-slate-200 text-slate-700" data-id="element-574">
                        {course.created}
                      </td>
                      <td className="px-4 py-3" data-id="element-575">
                        <div className="flex items-center gap-2 text-sm" data-id="element-576">
                          <button className="text-blue-600 hover:underline" data-id="element-577">
                            Edit
                          </button>
                          <span className="text-slate-300" data-id="element-578">|</span>
                          <button className="text-red-600 hover:underline" data-id="element-579">
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}